import React from "react";

import "./CoaTemplatePanel.css";

const CoaTemplateListItem = ({
  template,
  isSelected,
  onSelectTemplate,
}) => (
  <button
    type="button"
    className={`CoaTemplateListItem${isSelected ? " CoaTemplateListItem--selected" : ""}${template.isDefault ? " CoaTemplateListItem--default" : ""}`}
    onClick={() => onSelectTemplate(template)}
    aria-pressed={isSelected}
    title={template.name}
  >
    <span className="CoaTemplateListItem__Name">{template.name}</span>
    {template.isDefault && (
      <span className="CoaTemplateListItem__DefaultBadge">Default</span>
    )}
  </button>
);

export default CoaTemplateListItem;
